import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import LoadAttendees from '@/connection/audiences/all-audiences';
import type { RootState } from '@/store/root-state';
import {
  selectAllAttendeesFields,
  selectAllAttendeesPage,
  selectAllAttendeesPageSize,
  selectAllAttendeesSearch,
  selectAllAttendeesSort,
  selectAllAttendeesSortDirection,
  selectAllAttendeesStatus,
  selectAllAttendeesRegistrationFilter,
} from '../selectors';
import { selectWorkingProjectUuid } from '@/store/slices/project/selectors';
import { selectActiveChannel } from '@/store/slices/user/selectors';

export const fetchAllAttendees = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async (_: void, { getState, signal }) => {
      const state = getState() as RootState;
      const channel = selectActiveChannel(state);
      const eventUuid = selectWorkingProjectUuid(state)!;
      const page = selectAllAttendeesPage(state);
      const pageSize = selectAllAttendeesPageSize(state);
      const search = selectAllAttendeesSearch(state);
      const sort = selectAllAttendeesSort(state);
      const sortDirection = selectAllAttendeesSortDirection(state);
      const fields = selectAllAttendeesFields(state);
      const status = selectAllAttendeesStatus(state);
      const registrationStatusFilter = selectAllAttendeesRegistrationFilter(state);

      return await LoadAttendees({
        channel,
        eventUuid,
        page: page - 1,
        pageSize,
        search,
        sort,
        sortDirection,
        fields,
        status,
        registrationStatusFilter,
        signal,
      });
    },
    {
      options: {
        condition: (_, { getState }) => {
          const state = getState() as RootState;
          return !state.audiences.allAttendees.loading;
        },
      },
      pending: (state) => {
        state.allAttendees.loading = true;
      },
      fulfilled: (state, action) => {
        state.allAttendees.users = action.payload.data || [];
        state.allAttendees.total = action.payload.total || 0;
        state.allAttendees.loading = false;
      },
      rejected: (state, action) => {
        if (action.meta.aborted) return;
        state.allAttendees.loading = false;
        console.error(action.error);
      },
    }
  );
